module.exports = __webpack_public_path__ + "static/img/looking-ahead-2018-priorities-hero.d84f9ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/looking-ahead-2018-priorities-hero.jpg
// module id = 7Ywk
// module chunks = 0